import connector from './containers/connector';

export default connector;
